
import { Col, TitleFont } from '../../../libs/base/base-style';

import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { styled } from '@mui/material/styles';

export const Title = styled(TitleFont)(({ theme }) => ({
    fontSize: '35px',
    margin: '20px',
    fontWeight: 800,
    fontFamily: 'inherit',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.9rem',

    },
}));

export const StyledBtn = styled(Button)`
    background-color: transparent !important;
    color: white !important;
    font-weight: 900 !important;
    font-size: 14px !important;
    text-transform: none !important;
`

export const FilledBtn = styled(StyledBtn)`
    background-color: #408697 !important;
    font-weight: 900 !important;
    font-family: inherit;
    height:40px !important;
    width:250px !important;
    font-size: 12px !important;
    border-radius:0 !important;
`
export const StyledIcon = styled(EditOutlinedIcon)`
    color:#408697;
`

export const VisitTitle = styled(Title)`
    margin:0;
    margin-bottom:15px;
`

export const SubTitle = styled(VisitTitle)`
    font-size:25px;
    margin-top:40px;
    margin-bottom:40px;
`